// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Admin: shell (nav, status, refresh)
 */

.AdminLayout_page__6TJwS {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: var(--space-6) var(--gutter) var(--space-16);
  box-sizing: border-box;
}

.AdminLayout_bar__X4aii {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--space-3);
  padding-bottom: var(--space-3);
  border-bottom: 1px solid var(--border);
}

.AdminLayout_nav__\\+a8Xw,
.AdminLayout_tools__BsLFf {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-3);
}

.AdminLayout_link__\\+6KQn,
.AdminLayout_active__owGJz {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  font-weight: 600;
  font-size: 0.9375rem;
  text-decoration: none;
  color: var(--text-secondary);
  padding: var(--space-1) var(--space-2);
  border-radius: var(--radius-sm);
}

.AdminLayout_active__owGJz {
  color: var(--primary);
  background: var(--surface-brand-wash);
}

.AdminLayout_link__\\+6KQn:hover {
  color: var(--text-primary);
}

.AdminLayout_status__SbU9Y,
.AdminLayout_updated__QJ98R {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  font-size: 0.8125rem;
  color: var(--text-secondary);
}

.AdminLayout_dot__NiMep,
.AdminLayout_dotUp__q0zJt,
.AdminLayout_dotDown__5\\+I5b {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--gray-400);
}

.AdminLayout_dotUp__q0zJt {
  background: var(--success);
}

.AdminLayout_dotDown__5\\+I5b {
  background: var(--error);
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/Admin/AdminLayout.module.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,qDAAqD;EACrD,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;;;EAGE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["/*\n * Admin: shell (nav, status, refresh)\n */\n\n.page {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-5);\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: var(--space-6) var(--gutter) var(--space-16);\n  box-sizing: border-box;\n}\n\n.bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--space-3);\n  padding-bottom: var(--space-3);\n  border-bottom: 1px solid var(--border);\n}\n\n.nav,\n.tools {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--space-3);\n}\n\n.link,\n.active {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-1);\n  font-weight: 600;\n  font-size: 0.9375rem;\n  text-decoration: none;\n  color: var(--text-secondary);\n  padding: var(--space-1) var(--space-2);\n  border-radius: var(--radius-sm);\n}\n\n.active {\n  color: var(--primary);\n  background: var(--surface-brand-wash);\n}\n\n.link:hover {\n  color: var(--text-primary);\n}\n\n.status,\n.updated {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-1);\n  font-size: 0.8125rem;\n  color: var(--text-secondary);\n}\n\n.dot,\n.dotUp,\n.dotDown {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--gray-400);\n}\n\n.dotUp {\n  background: var(--success);\n}\n\n.dotDown {\n  background: var(--error);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `AdminLayout_page__6TJwS`,
	"bar": `AdminLayout_bar__X4aii`,
	"nav": `AdminLayout_nav__+a8Xw`,
	"tools": `AdminLayout_tools__BsLFf`,
	"link": `AdminLayout_link__+6KQn`,
	"active": `AdminLayout_active__owGJz`,
	"status": `AdminLayout_status__SbU9Y`,
	"updated": `AdminLayout_updated__QJ98R`,
	"dot": `AdminLayout_dot__NiMep`,
	"dotUp": `AdminLayout_dotUp__q0zJt`,
	"dotDown": `AdminLayout_dotDown__5+I5b`
};
export default ___CSS_LOADER_EXPORT___;
